import "./StrategyBuilderStockSummaryComponent.scss";
import {IComponentOptions} from "angular";
import {Stock} from "../../models/Stock";

export const StockSummary = "tfStrategyBuilderStockSummary";

export function stockSummary(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/stock-summary/StrategyBuilderStockSummaryComponent.html`,
        bindings: {
            stock: "<"
        },
        controllerAs: "ctrl",
        controller: StrategyBuilderStockInfoComponentController
    };
}

export class StrategyBuilderStockInfoComponentController {
    public stock: Stock;
}
